import { http } from "./http.js";

async function getRegion(resource, id) {
  const response = await http.get(`/${resource}/${id === "0" ? "new" : id}`);
  return {
    id: response.data.Id,
    title: response.data.Title,
    code: response.data.Code,
    country: {
      id: response.data.Country.Id,
      title: response.data.Country.Title,
      inputLanguage: response.data.Country.InputLanguage,
    },
    isRemoved: response.data.IsRemoved,
    isConfirmed: response.data.IsConfirmed,
  };
}

async function updateRegion(resource, id, entity) {
  const response = await http.put(`${resource}/${id}`, entity);
  return response;
}

async function createRegion(resource, entity) {
  const response = await http.post(`/${resource}`, entity);
  return response;
}

async function changeRemovedState(resource, entity) {
  const response = await http.patch(
    `/${resource}/${entity.id}/rpc/change-removed-state`,
    {
      value: !entity.isRemoved,
    },
  );
  return response;
}

async function deleteRegion(resource, id) {
  const response = await http.delete(`${resource}/${id}`);
  return {
    id: response.data.Id,
    title: response.data.Title,
    code: response.data.Code,
    country: {
      id: response.data.Country.Id,
      title: response.data.Country.Title,
      inputLanguage: response.data.Country.InputLanguage,
    },
    isRemoved: response.data.isRemoved,
  };
}

async function getRegionReference(resource, id) {
  const response = await http.get(`${resource}/referencies/${id}`);
  return {
    id: response.data.Id,
    title: response.data.Title,
    code: response.data.Code,
    country: {
      id: response.data.Country.Id,
      title: response.data.Country.Title,
      inputLanguage: response.data.Country.InputLanguage,
    },
    isRemoved: response.data.isRemoved,
  };
}

async function fetchAllRegions(resource, queryParams) {
  const response = await http.get(`${resource}/referencies?${queryParams}`);
  return response.data.map(i => {
    return {
      text: i.Title,
      value: i.Id,
      code: i.Code,
      country: {
        id: i.Country.Id,
        title: i.Country.Title,
        inputLanguage: i.Country.InputLanguage,
      },
    };
  });
}

async function searchReferencies(resource, search) {
  const response = await http.get(
    `${resource}/referencies?searchTerm=${search}`,
  );
  if (Array.isArray(response.data)) {
    return response.data.map(i => {
      return {
        text: i.Title,
        value: i.Id,
        code: i.Code,
        country: {
          id: i.Country.Id,
          title: i.Country.Title,
          inputLanguage: i.Country.InputLanguage,
        },
      };
    });
  } else {
    response.data = [];
    return response;
  }
}

export {
  getRegion,
  updateRegion,
  createRegion,
  changeRemovedState,
  deleteRegion,
  getRegionReference,
  fetchAllRegions,
  searchReferencies,
};
